import Header from "../../../component/menu/Header";
import SideMenu from "../../../component/menu/SideMenu";
import { constants } from "../../../constant/constants";
import FormHeaderComponent from "../../../component/FormHeaderComponent";
import SupplierAddEditComponent from "../../../component/inventory/supplier/SupplierAddEditComponent";

export default function SupplierAdd() {
  return (
    <div className="flex flex-col">
      <Header
        title={`McDonalds Food Chains`}
        menu={constants.MENU.INVENTORY}
        currentMenuKey={"T_7_S_7_L_3"}
      />
      <div className="flex flex-row bg-prewhite">
        <SideMenu
          title={`McDonalds Food Chain`}
          menu={constants.MENU.INVENTORY}
        />
        <div className="p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <FormHeaderComponent
              title={"Add Supplier"}
              listRoute="/inventory/supplier"
            />
          </div>

          <div className="w-full flex justify-center">
            <SupplierAddEditComponent />
          </div>
        </div>
      </div>
    </div>
  );
}
